'use strict';

var React = require('react');

var SvgEyeDropperMinor = function SvgEyeDropperMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m9.586 6.172-.879-.88a1 1 0 1 0-1.414 1.415l.879.879-5.293 5.293a3 3 0 1 0 4.241 4.241l5.293-5.293.879.88a1 1 0 0 0 1.414-1.415l-.879-.879 3.293-3.293a3 3 0 1 0-4.24-4.24l-3.294 3.292Zm0 2.828 1.414 1.414-5.293 5.293a1 1 0 0 1-1.414-1.414l5.293-5.293Z"
  }));
};

exports.SvgEyeDropperMinor = SvgEyeDropperMinor;
